export type State = {
  snoozedAt: Date | undefined | null;
};

export const initialState: State = {
  snoozedAt: null,
};

export default function reducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case 'connectionStateBanner/SNOOZE':
      return { ...state, snoozedAt: action.snoozedAt };
    case 'connectionStateBanner/WAKEUP':
      return { ...state, snoozedAt: null };
    default:
      return state;
  }
}

type snoozeAction = {
  type: 'connectionStateBanner/SNOOZE';
  snoozedAt: Date;
};

export function snooze(): snoozeAction {
  return {
    type: 'connectionStateBanner/SNOOZE',
    snoozedAt: new Date(),
  };
}

type wakeupAction = {
  type: 'connectionStateBanner/WAKEUP';
};

export function wakeup(): wakeupAction {
  return {
    type: 'connectionStateBanner/WAKEUP',
  };
}

export type ConnectionStateBannerActions = snoozeAction | wakeupAction;
